<template>
  <hr class="my-6 hr-grey" />
  <ion-row>
    <ion-col class="flex items-center justify-between">
      <ion-text class="text-md font-bold ion-text-brand"
        >Multi-Factor Authentication</ion-text
      >
      <ion-text
        class="rounded flex items-center bg-notice-green"
        v-if="mfaEnabled"
      >
        <ion-icon
          src="/assets/general/icon-correct.svg"
          class="w-[14px] pl-2"
        ></ion-icon>
        <small class="p-1 pr-2 bold text-notice-green">Enabled</small>
      </ion-text>
      <ion-text class="rounded flex items-center bg-notice-red" v-else>
        <ion-icon
          src="/assets/general/icon-incorrect.svg"
          class="w-[14px] pl-2"
        ></ion-icon>
        <small class="p-1 pr-2 bold text-notice-red">Disabled</small>
      </ion-text>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-text class="text-[13px] ion-text-brand mt-1 block">
        Use MFA to add another layer of security to your account.
      </ion-text>
    </ion-col>
  </ion-row>
  <button
    expand="block"
    fill="outline"
    class="button-outline button-icon button-icon-security-mfa mt-6 mb-0"
    @click="nextStep"
    data-cy="security-details-button-mfa"
  >
    <span class="block capitalize text-[14px] height-[60px]"
      >Change MFA Settings</span
    >
  </button>
</template>

<script setup>
import { computed, onMounted, watch } from "vue";
import router from "@/router";
import { useCustomerStore } from "@/stores";
import { storeToRefs } from "pinia";
import { asyncComputed } from "@vueuse/core";
import { useSecureStorage } from "@/composables/secureStorage";
const { keys, getStorage } = useSecureStorage();
const mfaStorage = asyncComputed(
  async () => await getStorage({ key: keys.mfa }),
  null
);
const mfaStorageObj = computed(() =>
  mfaStorage.value ? { ...JSON.parse(mfaStorage.value.value) } : null
);
const customerStore = useCustomerStore();
const { mfaEnabled } = storeToRefs(customerStore);
const {
  setMfaLoginRequired,
  setMfaLoginType,
  setMfaLoginContact,
  setMfaEnabled,
} = customerStore;
const nextStep = () => {
  router.push({ name: "MfaSettings" });
};
const mfaStorageInit = () => {
  if (mfaStorageObj.value) {
    setMfaLoginRequired(mfaStorageObj.value.required);
    setMfaLoginType(mfaStorageObj.value.type);
    setMfaLoginContact(mfaStorageObj.value.contact);
    setMfaEnabled(mfaStorageObj.value.enabled);
  }
};
onMounted(() => {
  mfaStorageInit();
});
watch(
  mfaStorageObj,
  () => {
    mfaStorageInit();
  },
  { immediate: true }
);
</script>
